"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_query_1 = require("react-query");
var React = __importStar(require("react"));
var react_query_2 = require("react-query");
var api_1 = require("../../api");
var loading_modal_1 = __importDefault(require("../../components/loading-modal"));
var activate_wipesless_bundles_1 = require("../../mutations/activate-wipesless-bundles");
var index_1 = require("./index");
var useContext = React.useContext, useState = React.useState;
exports.default = (function () {
    var _a = useContext(index_1.AppContext), goNext = _a.goNext, groupedSubscription = _a.groupedSubscription, recordSaveAndAcceptedOfferDeflectionInSnacktime = _a.recordSaveAndAcceptedOfferDeflectionInSnacktime;
    if (!groupedSubscription)
        return null;
    var cancel = window.accountApp.settings.cancel;
    var _b = __read(useState(false), 2), isMutating = _b[0], setIsMutating = _b[1];
    var queryClient = (0, react_query_2.useQueryClient)();
    var _c = (0, react_query_1.useMutation)("updateSubscription", function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(activate_wipesless_bundles_1.ACTIVATE_WIPESLESS_BUNDLES, variables); }, {
        onSuccess: function () { return queryClient.invalidateQueries('getCustomerSubscriptions'); },
    }), activateWipeslessBundles = _c.mutateAsync, activateWipeslessBundlesError = _c.error;
    // skip if save is not allowed, or customer can already access the save
    if (cancel.customerCanAccessWipeslessBundles || !cancel.allowWipeslessBundleSave) {
        goNext();
        return null;
    }
    return (React.createElement("div", { className: 'padding-4 medium-padding-8' },
        React.createElement(loading_modal_1.default, { error: activateWipeslessBundlesError, isLoading: isMutating }),
        React.createElement("div", { className: 'text-center' },
            React.createElement("div", { className: 'margin-bottom-4 font-lighter' }, cancel.wipeslessBundlesTopline),
            React.createElement("h3", null, cancel.wipeslessBundlesTitle),
            React.createElement("div", { className: 'divider bg-cornflower-blue margin-vertical-4 margin-horizontal-auto', style: { width: 56 } }),
            React.createElement("div", { className: 'lh1 circle bg-cornflower-blue margin-horizontal-auto margin-vertical-8 align-center flex-dir-column flex-container ', style: { height: 115, width: 115 } },
                React.createElement("div", { className: 'text-hippie-blue strike' }, cancel.wipeslessBundlesOldPrice),
                React.createElement("div", { className: 'text-white h3 margin-vertical-1' }, cancel.wipeslessBundlesNewPrice),
                React.createElement("div", { className: 'text-white text-uppercase' }, "Bundle")),
            React.createElement("div", { className: 'text-gray h5 margin-bottom-8 font-lighter margin-horizontal-auto', style: { maxWidth: 300 } }, cancel.wipeslessBundlesBody),
            React.createElement("button", { className: 'cell medium-6 button large wisteria padding-vertical-5', id: 'account-wipesless-bundle-btn' // for GA
                , onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                setIsMutating(true);
                                return [4 /*yield*/, activateWipeslessBundles({ subscriptionId: groupedSubscription.subscription.id })];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, recordSaveAndAcceptedOfferDeflectionInSnacktime('Changed to wipesless bundle')];
                            case 2:
                                _a.sent();
                                window.location.reload();
                                return [2 /*return*/];
                        }
                    });
                }); } }, cancel.wipeslessBundlesYesButton),
            React.createElement("button", { className: 'cell medium-6 button white small text-uppercase padding-vertical-5', onClick: goNext },
                React.createElement("span", { className: 'bordered border-light-wisteria', style: { borderWidth: '0 0 1px', paddingBottom: '4px' } }, cancel.wipeslessBundlesNoButton)))));
});
